import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ParagraphStyles } from '@desygner/ui-editor-menus';
import ReactAppBuilder from 'src/utils/react-app-builder';
import { formatMetadata } from './paragraph-style-utils';

class ParagraphStylesView extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp () {
    super.mountApp(this.App);
  }

  onStyleClick (styleId) {
    INKIVE.DesignFacade.set({
      data_paragraph_style: {
        id: styleId
      }
    });
  }

  loadFonts (data) {
    return Promise.all(Object.entries(data).map(([family, attributes]) => {
      if (attributes.customFontId) {
        return INKIVE.FontsFactory.getCustomFont(attributes.customFontId);
      }

      return INKIVE.FontsFactory.addSystemFontCSS(family);
    }));
  }

  mapProps () {
    const metadata = useSelector(state => state.metadata.paragraph_styles);
    const { folders, styles, fonts } = useMemo(() =>
      formatMetadata(metadata)
    , [metadata]);

    useEffect(() => {
      this.loadFonts(fonts);
    }, []);

    return {
      folders,
      styles,
      labels: {
        searchPlaceholder: INKIVE.TranslateHelper.translate('top_submenu.text.search_placeholder')
      },
      onStyleClick: this.onStyleClick.bind(this)
    };
  }

  App = () => {
    const props = this.mapProps();

    return <ParagraphStyles {...props} />;
  };
}

export default new ParagraphStylesView({
  appId: 'react-text-paragraph-styles-app',
  targetNodeSelector: '#tabText .tab-content .paragraph_styles'
});
